/**
 * Created by Filip de Tillier on 05.12.2018.
 */
import Vue from 'vue';
import Online from '../../views/Panel/Devices/component/Online';
import Registered from '../../views/Panel/Devices/component/Registered.vue';
import LastStatus from '../../views/Panel/Devices/component/LastStatus.vue';
import Status from '../../views/Panel/Devices/component/Status.vue';
/**
  * @module Store/userData
  * @description Store for user data
  */
 
/**
  * @constant State of user data
  * @type {object}
 * */
 
const state = {
    deviceStatus:[],
    onPage: 10,
    currentDevicePage: 1,
    baseUrl: process.env.VUE_APP_LOCATION,
    httpOptions:{
        auth: {
            username: 'admin@di-support.com',
            password: 'di-cph-a-01'
        }
    },
    querySchema:{
        direction: 'direction',
        sortField: 'sortField',
        currentPage: 'page',
        perPage: 'limit'
    },
    paginationSchema:{
        per_page: 'limit',
        total: 'all',
        current_page: 'page'
    },
    fields:[  
        {
            name: 'deviceId',
            title: 'Device ID',
            sortField: 'deviceId',
            searchField: 'deviceId',
            searchTitle: 'Search ID'
        },
        {
            name: 'media',
            title: 'Media',
            sortField: 'media',
            searchField: 'media',
            searchTitle: 'Less then'
        },
        {
            name: 'printer',
            title: 'Printer',
            sortField: 'printer',
            searchField: 'printer',
            searchTitle: 'Printer',
            searchValues: [
                { title: 'all', value: '' },
                { title: 'rs1', value: 'rs1' },
                { title: 'ds820', value: 'ds820' }
            ]
        },
        {
            name: 'teamviewerId',
            title: 'Teamviewer',
            sortField: 'teamviewerId',
            searchField: 'teamviewerId',
            searchTitle: 'Search Teamviewer'
        },    
        {
            name: 'version',
            title: 'Version',
            sortField: 'version',
            searchField: 'version',
            searchTitle: 'Search Version'
        },        
        {
            name: 'externalID',
            title: 'ExternalID'
        },
        {
            name: 'online',
            title: 'online',
            searchField: 'online',
            sortField: 'online',
            component: Online,
            searchValues: [
                { title: 'all', value: '' },
                { title: 'online', value: 'online' },
                { title: 'offline', value: 'offline' }
            ]
        },
        { name: 'registered',
            title: 'registered',
            sortField: 'registered',
            searchField: 'registered',
            searchTitle: 'registered',
            component: Registered,
            searchValues: [
                { title: 'all', value: '' },
                { title: 'registered', value: 'registered' },
                { title: 'unregistered', value: 'unregistered' }
            ]
        },
        {
            name: 'status',
            title: 'Status',
            component: Status
        },
        {
            name: 'lastStatus',
            title: 'Last status',
            sortField: 'lastStatus',
            component: LastStatus
        }
    ],
    cubesSortOrder: [
        {
            sortField: 'updatedAt',
            field: 'updatedAt',
            direction: 'desc'
        }
    ],
    qs: {},
    selectedShop: {},
    selectedUser: {},
    shops: [],
    devices:[]
};
 
/**
  * @constant Getters
  * @type {object}
 * */
 
const getters = {
    getDevicesUser: state => state.selectedUser,
    getCubesSortOrder: state => state.cubesSortOrder,
    dgetUserShops: state => state.shops,
    dgetSelectedShops: state => state.selectedShop,
    dgetSelectedUser: state => state.selectedUser,
    getQsShops: state => state.qs.shopId,
    getDeviceField: state => state.fields,
    getDevicesPaginationSchema: state => state.paginationSchema,
    getDevicesQuerySchema: state => state.querySchema,
    getHttpOptions: state => state.httpOptions,
    getSelectedDevices: state => state.devices,
    getDevicesOnPage: (state) => state.onPage,
    getDevicesCurrentPage: (state) => state.currentDevicePage,
    getBaseUrl: (state) => state.baseUrl,
    getDeviceStatus: (state) => state.deviceStatus
};
 
/**
  * @constant Mutations
  * @type {object}
 * */
 
const mutations = {
    selectedUser: (state, selected) => state.selectedUser = selected,
    selectedShop: (state, selected) => state.selectedShop = selected,
    setQs: (state, toSet) => state.qs = toSet,
    dUserShops: (state, shops) => state.shops = shops,
    selectedDevices: (state, devices) => state.devices = devices,
    setOnPageLimitDevice: (state, onPage) => state.onPage = onPage,
    setCurrentDevicePage: (state, currentPage) => state.currentDevicePage = currentPage, 
    setDeviceStatus: (state, deviceStatus) => state.deviceStatus = deviceStatus
};
 
/**
  * @constant Actions
  * @type {object}
 **/
 
const actions = {  
    setDeviceStatus ({ commit }, status) {
        commit('setDeviceStatus', status);
    },    
    setCurrentDevicePage ({ commit }, currentPage) {
        commit('setCurrentDevicePage', currentPage);
    },    
    setOnPageLimitDevice ({ commit }, onPage) {
        commit('setOnPageLimitDevice', onPage);
    },
    setSelectedDevices ({ commit }, devices) {
        commit('selectedDevices', devices);
    },
    async changeShops ({ commit, dispatch }, shop){
        commit('selectedShop', shop);
        return  dispatch('mergeQs');
    },
    async changeUser ({ commit, dispatch }, user){
        commit('selectedUser', user);
        if(user && user.id){
            dispatch('dGetShopsUser', user.id);
        }
        return  dispatch('mergeQs');
    },
    async dGetShopsUser ({ commit }, id){
        if(id){
            let { data } = await Vue.axios.get(`/stores/store/user/${id}`);
            commit('dUserShops', data);
            return data;
        }
        commit('dUserShops', []);
    },
    async mergeQs ({ commit, state }){
        //TABLE FIELDS
        const filters = {};
 
        //OWNER SELECTOR
        if(state.selectedUser && state.selectedUser.id){
            filters['userId'] = state.selectedUser.id;
        }else if(filters['userId']){
            delete filters['userId'];
        }
 
        //SHOP SELECTOR
 
        if(state.selectedShop){
            filters['shopId'] = state.selectedShop.length ? state.selectedShop.map((s) => s.id) : state.selectedShop.id;
        } else {
            delete filters['shopId'];
        }
 
        commit('setQs', filters);
    },
    async getDeviceStatusData ({ commit }, { id }) {
        const url = `/cubes/cube/${id}`;
        const { data: res = {} } = await Vue.axios.get(url);
        const { cube = {} } = res;
        const { data = {} } = cube;
        return data;
    }
};
 
export default {
    state,
    getters,
    mutations,
    actions
};
 